export function logosMarquee() {
	const marquees = Array.from(document.querySelectorAll('.logos-marquee'));
	if (!marquees.length) {
		return;
	}

	const makeSequencePassive = (sequence) => {
		sequence.setAttribute('aria-hidden', 'true');
		sequence.removeAttribute('data-marquee-base');
		sequence.querySelectorAll('a').forEach((link) => {
			link.removeAttribute('href');
			link.setAttribute('tabindex', '-1');
		});
		sequence.querySelectorAll('img').forEach((img) => {
			img.alt = '';
		});
	};

	const setupMarquee = (marquee) => {
		const track = marquee.querySelector('.logos-marquee-track');
		if (!track) {
			return;
		}

		let baseSequence = track.querySelector('.logos-marquee-sequence[data-marquee-base="true"]:not([data-generated="true"])');
		if (!baseSequence) {
			baseSequence = track.querySelector('.logos-marquee-sequence:not([data-generated="true"])');
			if (baseSequence) {
				baseSequence.setAttribute('data-marquee-base', 'true');
			}
		}
		if (!baseSequence) {
			return;
		}

		marquee.classList.remove('is-ready');
		track.style.transform = 'translateX(0)';

		if (!baseSequence.dataset.baseHtml) {
			baseSequence.dataset.baseHtml = baseSequence.innerHTML;
		}
		baseSequence.innerHTML = baseSequence.dataset.baseHtml;

		track.querySelectorAll('.logos-marquee-sequence').forEach((sequence) => {
			if (sequence !== baseSequence) {
				sequence.remove();
			}
		});
		track.querySelectorAll('.logos-marquee-sequence[data-generated="true"]').forEach((clone) => clone.remove());

		const originalItems = Array.from(baseSequence.children);
		if (!originalItems.length) {
			return;
		}

		const containerWidth = Math.ceil(marquee.getBoundingClientRect().width);
		const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;

		while (baseSequence.scrollWidth < containerWidth && originalItems.length) {
			originalItems.forEach((item) => {
				baseSequence.appendChild(item.cloneNode(true));
			});
			if (baseSequence.children.length > 300) {
				break;
			}
		}

		const safeSequenceWidth = Math.ceil(baseSequence.getBoundingClientRect().width);
		if (!safeSequenceWidth) {
			return;
		}

		const cloneBefore = baseSequence.cloneNode(true);
		cloneBefore.dataset.generated = 'true';
		makeSequencePassive(cloneBefore);
		const cloneAfter = baseSequence.cloneNode(true);
		cloneAfter.dataset.generated = 'true';
		makeSequencePassive(cloneAfter);

		track.prepend(cloneBefore);
		track.append(cloneAfter);

		track.style.setProperty('--logos-marquee-shift', `${safeSequenceWidth + gap}px`);

		const minTrackWidth = containerWidth + safeSequenceWidth + gap;
		let guard = 0;
		while (track.scrollWidth < minTrackWidth && guard < 10) {
			const clone = baseSequence.cloneNode(true);
			clone.dataset.generated = 'true';
			makeSequencePassive(clone);
			track.appendChild(clone);
			guard++;
		}

		marquee.classList.add('is-ready');
	};

	const initializeAll = () => {
		marquees.forEach((marquee) => setupMarquee(marquee));
	};

	initializeAll();
	let resizeTimer = null;
	window.addEventListener('resize', () => {
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(initializeAll, 120);
	});
}
